
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planetary-meditation",
      function () {
        return require("private-next-pages/planetary-meditation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planetary-meditation"])
      });
    }
  